export interface SendEmailDialogFormFields {
    recipients: string[];
    ccs: string[];
    sendMeACopy: boolean;
    subject: string;
    body: string;
}